<template>
  <div
    data-qa="lpu_loyalty_program_label"
    class="d-inline-flex align-center gc-2 py-1 px-2 rounded bg-gray-40 text--text cursor-pointer"
    @click="emit('click')"
  >
    <div>
      <div class="d-inline-flex align-center text-body-2 gc-1">
        {{ t('Получите', options) }}
        <span class="d-inline-flex align-center">
          <span class="ui-icon-four-pointed-star-fill ui-icon-fz-smaller special--text mr-1" />
          <span class="d-inline-flex text-subtitle-2">
            <span data-qa="lpu_loyalty_program_label_min_bonus">{{ minPercent }}</span>
            <template v-if="maxPercent">
              -<span data-qa="lpu_loyalty_program_label_max_bonus">{{ maxPercent }}</span>
            </template>
            %
          </span>
        </span>
        {{ t('бонусами', options) }}
      </div>
      <div
        v-if="welcomeBonusAmount"
        class="text-body-2"
      >
        {{ t('и', options) }}
        <span data-qa="lpu_loyalty_program_label_welcome_bonus">{{ welcomeBonusAmount.toLocaleString() }}</span>
        {{ t(`${welcomeBonusAmountText} сразу`, options) }}
      </div>
    </div>
    <span class="ui-icon-arrow-right ui-icon-fz-smaller icon-secondary--text" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import declensionByNum from 'src/utils/declensionByNum'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  minPercent: number
  maxPercent?: number
  welcomeBonusAmount?: number
}>()

type Emits = {
  (_event: 'click'): void
}

const emit = defineEmits<Emits>()

const welcomeBonusAmountText = computed(() => (
  typeof props.welcomeBonusAmount === 'number'
    ? declensionByNum(props.welcomeBonusAmount, [
      'приветственный',
      'приветственных',
      'приветственных',
    ])
    : ''
))
</script>
